/*
 * 判断obj是否为一个整数
 */
function isInteger(obj) {
  return Math.floor(obj) === obj
}

/*
 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
 * @param floatNum {number} 小数
 * @return {object}
 *   {times:100, num: 314}
 */
function toInteger(floatNum) {
  if (floatNum === undefined) floatNum = 0
  var ret = { times: 1, num: 0 }
  if (isInteger(floatNum)) {
    ret.num = floatNum
    return ret
  }
  var strfi = floatNum + ''
  var dotPos = strfi.indexOf('.')
  var len = strfi.substr(dotPos + 1).length
  var times = Math.pow(10, len)
  // var intNum
  // if (floatNum < 0) {
  //   intNum = parseInt(floatNum * times)
  // } else {
  //   intNum = parseInt(floatNum * times + 0.5, 10)
  // }
  // var intNum = parseInt(floatNum * times + 0.5, 10)//屏蔽掉（因为会将类似-1.53188转换成-1531870）
  // var intNum = parseInt(floatNum * times)
  ret.times = times
  ret.num = Math.round(floatNum * times)
  return ret
}

/**
 *
 * @param num {Number} 数字参数
 * @param digits {Number} 保留的有效位数
 * 返回字符串的
 */
/* function goFixed(num,digits){
    var sNum = Math.round(num*Math.pow(10, digits)).toString();
    var sLen = sNum.length;
    if (sLen <= digits) {
        var fNum = digits - sLen + 1;
        for (let i=0; i< fNum; i++) {
            sNum = '0' + sNum;
        }
    }
    return `${sNum.slice(0,sNum.length-digits)}.${sNum.slice(-digits)}`;
} */
// 返回保留有效数字精度的 数字
function goFixed(num, digits) {
  var pow = Math.pow(10, digits)
  return Math.round(num * pow) / pow
}

/*
 * 核心方法，实现加减乘除运算，确保不丢失精度
 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
 *
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
 * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
 *
 */
function operation(a, b, digits, op) {
  var o1 = toInteger(a)
  var o2 = toInteger(b)
  var n1 = o1.num
  var n2 = o2.num
  var t1 = o1.times
  var t2 = o2.times
  var max = t1 > t2 ? t1 : t2
  var result = null
  switch (op) {
    case 'add':
      if (t1 === t2) {
        // 两个小数位数相同
        result = n1 + n2
      } else if (t1 > t2) {
        // o1 小数位 大于 o2
        result = n1 + n2 * (t1 / t2)
      } else {
        // o1 小数位 小于 o2
        result = n1 * (t2 / t1) + n2
      }
      if (digits >= 0 && digits <= 20) {
        return goFixed(result / max, digits)
      }
      return result / max
    case 'subtract':
      if (t1 === t2) {
        result = n1 - n2
      } else if (t1 > t2) {
        result = n1 - n2 * (t1 / t2)
      } else {
        result = n1 * (t2 / t1) - n2
      }
      if (digits >= 0 && digits <= 20) {
        return goFixed(result / max, digits)
      }
      return result / max
    case 'multiply':
      result = (n1 * n2) / (t1 * t2)
      if (digits >= 0 && digits <= 20) {
        return goFixed(result, digits)
      }
      return result
    case 'divide':
      if (n1 === 0 || n2 === 0) return 0
      result = (n1 / n2) * (t2 / t1)
      if (digits >= 0 && digits <= 20) {
        return goFixed(result, digits)
      }
      return result
  }
}

function dateAdd(interval, number, date, add) {
  //如果add为true则加否则减
  switch (interval) {
    case '年': {
      if (add) date.setFullYear(date.getFullYear() + number)
      else date.setFullYear(date.getFullYear() - number)
      return date
      // break
    }
    case '月': {
      if (add) date.setMonth(date.getMonth() + number)
      else date.setMonth(date.getMonth() - number)
      return date
      // break
    }
    case '日': {
      if (add) date.setDate(date.getDate() + number)
      else date.setDate(date.getDate() - number)
      return date
      // break
    }
    default: {
      date.setDate(date.getDate() + number)
      return date
      // break
    }
  }
}
// 加减乘除的四个接口
function numberAdd(a, b, digits) {
  return operation(a, b, digits, 'add')
}
function numberSub(a, b, digits) {
  return operation(a, b, digits, 'subtract')
}
function numberMul(a, b, digits) {
  return operation(a, b, digits, 'multiply')
}
function numberDiv(a, b, digits) {
  return operation(a, b, digits, 'divide')
}

/**
 * 返回一个日期时间段
 *
 * @param {string} [type='YYYY-MM-DD'] 返回数据格式如YYYY-MM-DD HH:mm:ss等
 * @param {number} [number=1]
 * @param {string} [interval='月']
 * @param {*} [date=new Date()]
 * @param {boolean} [add = false] 如果add为true则加否则减
 */
function dateTimeRange(
  type = 'YYYY-MM-DD',
  number = 1,
  interval = '月',
  date = new Date(),
  add = false
) {
  let val1 = new Date().format(date, 'date', type)
  let val2 = new Date().format(dateAdd(interval, number, date, add), 'date', type)
  return add ? [val1, val2] : [val2, val1]
}

function getTimebyStrategy(val, type = 'YYYY-MM-DD') {
  let _arr = []
  if (val == '无') return _arr

  let arr = val.split(',')
  arr.forEach((el) => {
    let date = new Date().format(dateAdd('日', el - 0, new Date(), true), 'date', type)
    _arr.push(date)
  })
  console.log(_arr)
  return _arr
}

function convertCurrency(data) {
  if (!data) return '零'
  var dataFixed = parseFloat(data.replace(/,/g, ''))
  //金额整数部分
  var integerNum
  //金额小数部分
  var decimalNum

  if (dataFixed == 0) return data
  dataFixed = dataFixed.toString()
  // 将数据分开
  if (dataFixed.indexOf('.')) {
    let parts = dataFixed.split('.')
    integerNum = parts[0]
    decimalNum = parts[1]
  } else {
    integerNum = dataFixed
  }

  var nums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖')
  //基本单位
  var intRadice = new Array('', '拾', '佰', '仟')
  //对应整数部分扩展单位
  var intUnits = new Array('万', '亿', '兆')
  //小数基本单位
  var digUnits = new Array('角', '分', '毫', '厘')
  //整数金额时后面跟的字符
  var int = '整'
  var intUnit = '元'

  let currentyIntegerData = '',
    currentyDecimalData = ''
  // 第一步：将所有数字转为文字
  // 整数部分
  for (let i = 0; i < integerNum.length; i++) {
    currentyIntegerData += nums[parseInt(integerNum[i])]
  }
  integerNum = currentyIntegerData
  currentyIntegerData = ''
  // 小数部分
  if (decimalNum) {
    for (let i = 0; i < decimalNum.length; i++) {
      currentyDecimalData += nums[parseInt(decimalNum[i])]
    }
  }
  decimalNum = currentyDecimalData
  currentyDecimalData = ''

  //第二步：为数字加上单位描述
  //整数部分
  let j = 0,
    k = 0
  for (let i = integerNum.length - 1; i >= 0; i--) {
    if (j >= intRadice.length) {
      currentyIntegerData = intUnits[k++] + currentyIntegerData
      j = 0
    }

    currentyIntegerData =
      integerNum[i] + (integerNum[i] == '零' ? '' : intRadice[j]) + currentyIntegerData
    j++
    console.log(currentyIntegerData)
  }

  // 删除整数部分末尾是0的部分
  for (let i = currentyIntegerData.length - 1; i >= 0; i--) {
    // 整数部分只有0的情况，不删除
    if (
      currentyIntegerData[i] != '零' ||
      (currentyIntegerData.length == 1 && currentyIntegerData[i] == '零')
    )
      break
    else currentyIntegerData = currentyIntegerData.substr(0, i)
  }

  //第二步：为数字加上单位描述
  //小数部分
  j = 0
  if (decimalNum) {
    for (let i = 0; i < decimalNum.length; i++) {
      currentyDecimalData = currentyDecimalData + decimalNum[i] + digUnits[j++]
      console.log(currentyDecimalData)
    }
  }

  // 删除小数部分末尾是0的部分
  for (let i = currentyDecimalData.length - 1; i >= 0; i--) {
    if (currentyDecimalData[i] != '零') break
    else currentyDecimalData = currentyDecimalData.substr(0, i)
  }

  console.log(currentyIntegerData)
  console.log(currentyDecimalData)
  integerNum = currentyIntegerData
  decimalNum = currentyDecimalData
  if (decimalNum.length != 0) return integerNum + intUnit + decimalNum
  else return integerNum + intUnit + int
}

function getNowDate() {
  let nowDate = new Date()
  return (
    nowDate.getFullYear() +
    '-' +
    PrefixInteger(nowDate.getMonth() + 1) +
    '-' +
    PrefixInteger(nowDate.getDate()) +
    ' ' +
    PrefixInteger(nowDate.getHours()) +
    ':' +
    PrefixInteger(nowDate.getMinutes()) +
    ':' +
    PrefixInteger(nowDate.getSeconds())
  )
}

function getNowDateOne() {
  let nowDate = new Date()
  return (
    nowDate.getFullYear() +
    '-' +
    PrefixInteger(nowDate.getMonth() + 1) +
    '-' +
    PrefixInteger(nowDate.getDate())
  )
}

//格式化数据
function formatDate(date) {
  return (
    date.getFullYear() +
    '-' +
    PrefixInteger(date.getMonth() + 1) +
    '-' +
    PrefixInteger(date.getDate()) +
    ' ' +
    PrefixInteger(date.getHours()) +
    ':' +
    PrefixInteger(date.getMinutes()) +
    ':' +
    PrefixInteger(date.getSeconds())
  )
}
//返回具体具体的时间 HS 直接给定毫秒数
function getNewDate(date, day, HS) {
  let time = day * 24 * 60 * 60 * 1000
  let tempDate = HS ? HS : new Date(date).getTime() + time
  let formatDate = new Date(tempDate)
  let newDate =
    formatDate.getFullYear() +
    '-' +
    PrefixInteger(formatDate.getMonth() + 1) +
    '-' +
    PrefixInteger(formatDate.getDate()) +
    ' ' +
    PrefixInteger(formatDate.getHours()) +
    ':' +
    PrefixInteger(formatDate.getMinutes()) +
    ':' +
    PrefixInteger(formatDate.getSeconds())
  return newDate
}

//获取当月第一天至最后一天的日期段
function getNowMonthRang(type = 'YYYY-MM-DD') {
  const now = new Date()
  const one = `${now.getFullYear()}-${PrefixInteger(now.getMonth() + 1)}-01`
  let two = dateAdd('月', 1, new Date(one), true)
  two = dateAdd('日', 1, new Date(two), false)
  two = `${now.getFullYear()}-${PrefixInteger(now.getMonth() + 1)}-${PrefixInteger(two.getDate())}`
  return type === 'YYYY-MM-DD' ? [one, two] : [`${one} 00:00:00`, `${two} 23:59:59`]
}

function PrefixInteger(num, length = 2) {
  return (Array(length).join('0') + num).slice(-length)
}

// convertCurrency(103456000.80700);

// exports
export default {
  dateAdd,
  numberAdd,
  numberSub,
  numberMul,
  numberDiv,
  dateTimeRange,
  getTimebyStrategy,
  convertCurrency,
  getNowDate,
  getNowDateOne,
  formatDate,
  getNewDate,
  getNowMonthRang,
}
